import { AggregateStatusApi } from "@/features/accounts/finance/services/aggregate-status-api";
import { GetAggregateStatusRequestModel } from "@/features/accounts/finance/services/aggregate-status-model";

/// アグリゲーション状態取得処理
export class AggregateStatusService {
    private aggregateStatusApi = new AggregateStatusApi();

    /**
    * アグリゲーション状態取得API実行
    */
    public async getAggregateStatus(param: GetAggregateStatusRequestModel) {
        return await this.aggregateStatusApi.getAggregateStatus(param);
    }
}
